import { render, staticRenderFns } from "./GiftCardReport.vue?vue&type=template&id=83c980de&scoped=true"
import script from "./GiftCardReport.vue?vue&type=script&lang=js"
export * from "./GiftCardReport.vue?vue&type=script&lang=js"
import style0 from "./GiftCardReport.vue?vue&type=style&index=0&id=83c980de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83c980de",
  null
  
)

export default component.exports